import { _ as _classPrivateFieldGet, a as _classPrivateFieldInitSpec, b as _classPrivateFieldSet } from '../../../dist/classPrivateFieldGet-80e919e0.esm.js';
import { _ as _defineProperty } from '../../../dist/defineProperty-6a97efcd.esm.js';
import { err, ok } from 'neverthrow';
import { I as InitError, C as CreateActorError, a as ConnectError, D as DisconnectError, T as TransferError, B as BalanceError } from '../../../dist/connectors-ec5b9dab.esm.js';

/* babel-plugin-inline-import '../assets/plugLight.svg' */
// @ts-ignore
const plugLogoLight = "data:image/svg+xml;base64,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"; // @ts-ignore
/* babel-plugin-inline-import '../assets/plugDark.svg' */
const plugLogoDark = "data:image/svg+xml;base64,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";
var _config = /*#__PURE__*/new WeakMap();
var _identity = /*#__PURE__*/new WeakMap();
var _principal = /*#__PURE__*/new WeakMap();
var _client = /*#__PURE__*/new WeakMap();
var _ic = /*#__PURE__*/new WeakMap();
var _wallet = /*#__PURE__*/new WeakMap();
class PlugWallet {
  get identity() {
    return _classPrivateFieldGet(this, _identity);
  }
  get wallets() {
    return _classPrivateFieldGet(this, _wallet) ? [_classPrivateFieldGet(this, _wallet)] : [];
  }
  get principal() {
    return _classPrivateFieldGet(this, _principal);
  }
  get client() {
    return _classPrivateFieldGet(this, _client);
  }
  get ic() {
    return _classPrivateFieldGet(this, _ic);
  }
  constructor() {
    let userConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _defineProperty(this, "meta", {
      features: ["wallet"],
      icon: {
        light: plugLogoLight,
        dark: plugLogoDark
      },
      id: "plug",
      name: "Plug Wallet"
    });
    _classPrivateFieldInitSpec(this, _config, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _identity, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _principal, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _client, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _ic, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _wallet, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _config, {
      whitelist: [],
      host: window.location.origin,
      dev: true,
      onConnectionUpdate: () => {
        window.ic.plug.sessionManager.sessionData;
        // TODO: recreate actors
        // TODO: handle account switching
      },

      ...userConfig
    });
    _classPrivateFieldSet(this, _ic, window.ic?.plug);
  }
  set config(config) {
    _classPrivateFieldSet(this, _config, {
      ..._classPrivateFieldGet(this, _config),
      ...config
    });
  }
  get config() {
    return _classPrivateFieldGet(this, _config);
  }
  async init() {
    // TODO: handle account switching
    try {
      if (!_classPrivateFieldGet(this, _ic)) {
        return err({
          kind: InitError.NotInstalled
        });
      }
      const status = await this.status();
      if (status !== "disconnected") {
        await _classPrivateFieldGet(this, _ic).createAgent({
          host: _classPrivateFieldGet(this, _config).host,
          whitelist: _classPrivateFieldGet(this, _config).whitelist
        });
      }
      if (status === "connected") {
        // Never finishes if locked
        _classPrivateFieldSet(this, _principal, (await _classPrivateFieldGet(this, _ic).getPrincipal()).toString());
        _classPrivateFieldSet(this, _wallet, {
          principal: _classPrivateFieldGet(this, _principal),
          accountId: _classPrivateFieldGet(this, _ic).accountId
        });
      }
      return ok({
        isConnected: false
      });
    } catch (e) {
      console.error(e);
      return err({
        kind: InitError.InitFailed
      });
    }
  }
  async status() {
    if (!_classPrivateFieldGet(this, _ic)) {
      return "disconnected";
    }
    try {
      return await Promise.race([_classPrivateFieldGet(this, _ic).isConnected().then(c => {
        return c ? "connected" : "disconnected";
      }), new Promise(resolve => setTimeout(() => resolve("locked"), 1000))]);
    } catch (e) {
      return "disconnected";
    }
  }
  async isConnected() {
    try {
      if (!_classPrivateFieldGet(this, _ic)) {
        return false;
      }
      return await _classPrivateFieldGet(this, _ic).isConnected();
    } catch (e) {
      console.error(e);
      return false;
    }
  }
  async createActor(canisterId, idlFactory) {
    if (!_classPrivateFieldGet(this, _ic)) {
      return err({
        kind: CreateActorError.NotInitialized
      });
    }
    try {
      // Fetch root key for certificate validation during development
      if (_classPrivateFieldGet(this, _config).dev) {
        const res = await _classPrivateFieldGet(this, _ic).agent.fetchRootKey().then(() => ok(true)).catch(e => err({
          kind: CreateActorError.FetchRootKeyFailed
        }));
        if (res.isErr()) {
          return res;
        }
      }
      const actor = await _classPrivateFieldGet(this, _ic).createActor({
        canisterId,
        interfaceFactory: idlFactory
      });
      return ok(actor);
    } catch (e) {
      console.error(e);
      return err({
        kind: CreateActorError.CreateActorFailed
      });
    }
  }
  async connect() {
    try {
      if (!_classPrivateFieldGet(this, _ic)) {
        window.open("https://plugwallet.ooo/", "_blank");
        return err({
          kind: ConnectError.NotInstalled
        });
      }
      await _classPrivateFieldGet(this, _ic).requestConnect(_classPrivateFieldGet(this, _config));
      _classPrivateFieldSet(this, _principal, (await _classPrivateFieldGet(this, _ic).getPrincipal()).toString());
      if (_classPrivateFieldGet(this, _principal)) {
        _classPrivateFieldSet(this, _wallet, {
          principal: _classPrivateFieldGet(this, _principal),
          accountId: _classPrivateFieldGet(this, _ic).accountId
        });
        return ok(true);
      }
      return ok(true);
    } catch (e) {
      console.error(e);
      return err({
        kind: ConnectError.ConnectFailed
      });
    }
  }
  async disconnect() {
    try {
      if (!_classPrivateFieldGet(this, _ic)) {
        return err({
          kind: DisconnectError.NotInitialized
        });
      }
      // TODO: should be awaited but never finishes, tell Plug to fix
      _classPrivateFieldGet(this, _ic).disconnect();
      return ok(true);
    } catch (e) {
      console.error(e);
      return err({
        kind: DisconnectError.DisconnectFailed
      });
    }
  }
  async requestTransfer(opts) {
    const {
      to,
      amount,
      standard = "ICP",
      symbol = "ICP",
      decimals = 8,
      fee = 0,
      memo = BigInt(0),
      createdAtTime = new Date(),
      fromSubAccount = 0
    } = opts;
    try {
      const result = await _classPrivateFieldGet(this, _ic)?.requestTransfer({
        to,
        amount: amount * 100000000
      });
      switch (!!result) {
        case true:
          return ok({
            height: result.height
          });
        default:
          // TODO: ?
          return err({
            kind: TransferError.TransferFailed
          });
      }
    } catch (e) {
      console.error(e);
      return err({
        kind: TransferError.TransferFailed
      });
    }
  }
  async queryBalance() {
    try {
      if (!_classPrivateFieldGet(this, _ic)) {
        return err({
          kind: BalanceError.NotInitialized
        });
      }
      const assets = await _classPrivateFieldGet(this, _ic).requestBalance();
      return ok(assets);
    } catch (e) {
      console.error(e);
      return err({
        kind: BalanceError.QueryBalanceFailed
      });
    }
  }

  // TODO:

  // signMessage({ message }) {
  //   return this.#ic?.signMessage({message})
  // }

  // async getManagementCanister() {
  //   return this.#ic?.getManagementCanister()
  // }

  // batchTransactions(...args) {
  //   return this.#ic?.batchTransactions(...args)
  // }
}

export { PlugWallet };
